<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <pageheader :page-name="pageName" parent-page-name="Sell Sheets" parent-page-url="/sell-sheets" />
      <add-edit-form
        v-if="model"
        returnUrl="/sell-sheets"
        :apiBaseUrl="API_BASE_URL"
        :model="model"
        :fields="fields"
        :toEdit="toEdit"
      />
    </div>
    <!-- Content Wrapper END -->
  </div>
</template>

<script>
import Pageheader from '@/components/Pageheader.vue'
import AddEditForm from '@/components/AddEditForm.vue'
import SellSheet from '@/models/SellSheet'
/* eslint-disable no-undef */
export default {
  name: 'AddSellSheet',
  components: {
    Pageheader,
    AddEditForm
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    },
    pageName () {
      return this.toEdit ? 'Edit Sell Sheet' : 'Add Sell Sheet'
    }
  },
  data () {
    return {
      API_BASE_URL: 'sellsheet',
      model: null,
      fields: [
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Sort number', key: 'sort_no', type: 'number' },
        { label: 'Powerpoint Format', key: 'powerpoint', type: 'format' },
        { label: 'PDF Format', key: 'PDF', type: 'format' },
        { label: 'JPG Format', key: 'JPG', type: 'format' },
        { label: 'All Formats', key: 'ALL', type: 'format' }
      ]
    }
  },
  mounted () {
    this.fetchAllCategories()
    if (this.toEdit) {
      this.fetch()
    } else {
      this.model = new SellSheet()
    }
  },
  methods: {
    fetchAllCategories () {
      this.$store.dispatch('fetchAllSellSheetCategories')
        .then((result) => {
          if (!result.data.categories.length) {
            this.$router.push('/sell-sheet-categories')
            this.$toast.error('Please create categories first')
          }
          this.fields.splice(3, 0, { label: 'Category', key: 'category_id', type: 'select', options: result.data.categories })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    fetch () {
      this.$store.dispatch(this.API_BASE_URL + '/get', this.$route.params.id)
        .then((result) => {
          this.model = new SellSheet(result.sell_sheet)
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/SellSheets/AddEdit.vue